import React from 'react';
import { Link } from '@one-thd/sui-atomic-components';
var ReturnInitiatedLORPAlert = function (_a) {
    var trackingNumbers = _a.trackingNumbers;
    var lorpTrackingNumber = trackingNumbers.find(function (trackingInfo) {
        return trackingInfo === null || trackingInfo === void 0 ? void 0 : trackingInfo.startsWith('R');
    });
    return (React.createElement(React.Fragment, null,
        "Review your scheduled pickup time on",
        ' ',
        React.createElement(Link, { href: "https://www.hubgroup.com/about-us/contact-us/#orderTracking" }, "Hub Group's website"),
        ' ',
        "with your tracking number",
        lorpTrackingNumber && (React.createElement("span", { className: "sui-font-bold" }, " ".concat(lorpTrackingNumber))),
        '. ',
        "To reschedule, call 703-964-9500."));
};
export default ReturnInitiatedLORPAlert;
